import React from 'react';
import { MapPin, Phone, Mail, Clock, Heart, Instagram } from 'lucide-react';
import { FaSnapchatGhost } from 'react-icons/fa';
import './Footer.css';
import { Link } from 'react-router-dom';

// Icônes des réseaux sociaux avec style Lucide
const TikTokIcon = ({ size = 20 }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
  </svg>
);

// Ancienne icône Snapchat retirée (on utilise react-icons)

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Logo et description */}
          <div className="footer-section">
            <div className="footer-logo">
              <Heart className="footer-logo-icon" size={30} />
              <span className="footer-logo-text font-script">Pinky Cloud</span>
            </div>
            <p className="footer-description">
              Votre univers magique des desserts et bubble tea à Paris. 
              Une expérience gustative unique dans une ambiance cozy et chaleureuse.
            </p>
            <div className="social-icons">
              <a 
                href="https://www.instagram.com/pinkycloudcoffee/" 
                className="social-icon" 
                aria-label="Instagram"
                target="_blank" 
                rel="noopener noreferrer"
              >
                <Instagram size={20} />
              </a>
              <a 
                href="https://www.tiktok.com/@pinkycloudcoffee" 
                className="social-icon" 
                aria-label="TikTok"
                target="_blank" 
                rel="noopener noreferrer"
              >
                <TikTokIcon size={20} />
              </a>
              <a 
                href="https://www.snapchat.com/add/pinkycloudparis" 
                className="social-icon" 
                aria-label="Snapchat"
                target="_blank" 
                rel="noopener noreferrer"
              >
                <FaSnapchatGhost size={20} />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div className="footer-section">
            <h3>Navigation</h3>
            <ul className="footer-links">
              <li><Link to="/">Accueil</Link></li>
              <li><Link to="/menu">Menu</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/franchise">Franchise</Link></li>
              <li><Link to="/merch">Pinky Merch</Link></li>
            </ul>
          </div>

          {/* Informations de contact */}
          <div className="footer-section">
            <h3>Nous trouver</h3>
            <div className="contact-info">
              <div className="contact-item">
                <MapPin size={18} />
                <div>
                  <a 
                    href="https://maps.google.com/?q=49+Rue+du+Chemin+Vert,+75011+Paris" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="contact-link"
                  >
                    <p>49 Rue du Chemin Vert</p>
                    <p>75011 Paris</p>
                  </a>
                </div>
              </div>
              <div className="contact-item">
                <Phone size={18} />
                <div>
                  <a href="tel:+33759511319" className="contact-link">
                    <p>+33 7 59 51 13 19</p>
                  </a>
                </div>
              </div>
              <div className="contact-item">
                <Mail size={18} />
                <div>
                  <a href="mailto:contact@pinky-cloud.fr" className="contact-link">
                    <p>contact@pinky-cloud.fr</p>
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Horaires */}
          <div className="footer-section">
            <h3>
              <Clock size={20} />
              Horaires d'ouverture
            </h3>
            <div className="opening-hours">
              <div className="hours-item">
                <span className="day">Lundi</span>
                <span className="time">Fermé</span>
              </div>
              <div className="hours-item">
                <span className="day">Mardi - Jeudi</span>
                <span className="time">10h – 02h00</span>
              </div>
              <div className="hours-item">
                <span className="day">Vendredi</span>
                <span className="time">18h – 02h00</span>
              </div>
              <div className="hours-item">
                <span className="day">Samedi - Dimanche</span>
                <span className="time">10h – 02h00</span>
              </div>
            </div>
            <div className="delivery-info">
              <a 
                href="https://deliveroo.fr/fr/menu/paris/11eme-republique/pinky-cloud-49-rue-du-chemin-vert?utm_campaign=organic&utm_medium=referrer&utm_source=menu_share" 
                target="_blank" 
                rel="noopener noreferrer"
                className="delivery-link deliveroo-link"
              >
                Commande sur notre Deliveroo
              </a>
              <a 
                href="https://www.ubereats.com/fr/paris/food-delivery/pinky-cloud/49-rue-du-chemin-vert" 
                target="_blank" 
                rel="noopener noreferrer"
                className="delivery-link uber-link"
              >
                Commande sur notre Uber
              </a>
            </div>
          </div>
        </div>

        {/* Newsletter supprimée */}

        {/* Copyright */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div className="copyright">
              <p>&copy; 2025 Pinky Cloud. Tous droits réservés.</p>
            </div>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer; 